import React from 'react';
import R from 'ramda';
import Helmet from 'react-helmet';
import { firebase } from '../../common/lib/redux-firebase';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { Loading, Header, FilledButton, Footer } from '../app/components';
import { onMyPropertiesPresence } from '../../common/properties/actions';
import MyProperties from './MyProperties';

const MyPropertiesPage = ({ viewer, myProperties }) => {
  if (myProperties === undefined) {
    return <Loading loading loadingColor="#00E39A" backgroundColor="#ffffff" />;
  }

  if (myProperties === null) {
    return (
      <div>
        <div className="properties-page not-found">
          <Helmet title="Mínar eignir - Húsfinnur" />
          <Header title="Mínar eignir" from="/myProperties" />
          <h2>Þú átt engar eignir... :(</h2>
          {viewer &&
            <div className="button-wrapper">
              <Link
                to={{
                  pathname: '/createProperty',
                  state: { from: '/myProperties' },
                }}
              >
                <FilledButton
                  className="big"
                  content={
                    <div>
                      <span className="icon-new-property-icon" />
                      <p>Skráðu þína eign hér!</p>
                    </div>
                  }
                  color="#222222"
                  backgroundColor="#00e39a"
                />
              </Link>
            </div>
          }
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="properties-page">
      <Helmet title="Mínar eignir - Húsfinnur" />
      <Header title="Mínar eignir" from="/myProperties" />
      <h2>Mínar eignir</h2>
      <MyProperties myProperties={myProperties} />
      {viewer &&
        <div className="button-wrapper">
          <Link
            to={{
              pathname: '/createProperty',
              state: { from: '/myProperties' },
            }}
          >
            <FilledButton
              className="big"
              content={
                <div>
                  <span className="icon-new-property-icon" />
                  <p>Skráðu þína eign hér!</p>
                </div>
              }
              color="#222222"
              backgroundColor="#00e39a"
            />
          </Link>
        </div>
      }
      <Footer />
    </div>
  );
};

MyPropertiesPage.propTypes = {
  viewer: React.PropTypes.object,
  myProperties: React.PropTypes.array,
};

export default R.compose(
  connect(
    state => ({
      viewer: state.users.viewer,
      myProperties: state.properties.myProperties,
    }),
    { onMyPropertiesPresence },
  ),
  firebase((database, props) => {
    const propertiesPresenceRef = database.child('properties').orderByChild('ownerId').equalTo(props.viewer.id);
    return [
      [propertiesPresenceRef, 'on', 'value', props.onMyPropertiesPresence],
    ];
  }),
)(MyPropertiesPage);



// WEBPACK FOOTER //
// ./src/browser/properties/MyPropertiesPage.js